<!--The content below is only a placeholder and can be replaced.-->
<div id="chart">
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels"
    [title]="chartOptions.title" [colors]="chartOptions.colors"></apx-chart>
</div>
